/**
 * Microcopy conversacional para checkout (sin IA).
 */
import i18n from '@/i18n';

/**
 * @param {{
 *   serviceType: 'delivery'|'retiro'|'mesa',
 *   businessName?: string,
 *   chatCtx: { mood?: string|null, scheduledTime?: string|null }|null,
 *   orderNotesTrim: string
 * }} p
 */
export function buildCheckoutIntroCopy({ serviceType, businessName, chatCtx, orderNotesTrim }) {
  const mood = chatCtx?.mood || null;
  const scheduled =
    (chatCtx?.scheduledTime && String(chatCtx.scheduledTime).trim()) ||
    extractScheduledTimeFromNotes(orderNotesTrim);

  let headline = i18n.t('checkout.introHeadline');
  if (mood === 'frustrated') {
    headline = i18n.t('checkout.introHeadlineFrustrated');
  } else if (mood === 'happy') {
    headline = i18n.t('checkout.introHeadlineHappy');
  }

  const serviceLine =
    serviceType === 'delivery'
      ? i18n.t('checkout.introServiceDelivery')
      : serviceType === 'retiro'
        ? i18n.t('checkout.introServicePickup')
        : i18n.t('checkout.introServiceTable');

  const lines = [serviceLine, i18n.t('checkout.introConfirmHint')];

  return { headline, lines, scheduledHint: scheduled || null };
}

/** Heurística liviana si el chat guardó hora solo en notas. */
function extractScheduledTimeFromNotes(notes) {
  const s = String(notes || '').trim();
  if (!s) return null;
  const m = s.match(/\b(?:a\s+las|para\s+las|tipo|at|um|às)\s+(\d{1,2})(?::(\d{2}))?\b/i);
  if (m) {
    const hh = m[1];
    const mm = (m[2] || '00').padStart(2, '0');
    return `${hh}:${mm}`;
  }
  return null;
}

/**
 * @param {{
 *   hasName: boolean,
 *   hasPhone: boolean,
 *   serviceType: string,
 *   needsAddress: boolean,
 *   mood?: string|null
 * }} p
 */
export function buildCustomerSectionIntro({ hasName, hasPhone, serviceType, needsAddress, mood }) {
  const direct = mood === 'frustrated';
  if (!hasName || !hasPhone) {
    return direct
      ? i18n.t('checkout.customerNeedContactDirect')
      : i18n.t('checkout.customerNeedContact');
  }
  if (serviceType === 'delivery' && needsAddress) {
    return direct
      ? i18n.t('checkout.customerNeedAddressDirect')
      : i18n.t('checkout.customerNeedAddress');
  }
  return direct ? i18n.t('checkout.customerDataOkDirect') : i18n.t('checkout.customerDataOk');
}

/**
 * @param {{ hasScheduled: boolean, hasNotes: boolean, mood?: string|null }} p
 */
export function buildNotesRecapIntro({ hasScheduled, hasNotes, mood }) {
  if (!hasScheduled && !hasNotes) return null;
  if (mood === 'frustrated') {
    return i18n.t('checkout.notesRecapDirect');
  }
  return i18n.t('checkout.notesRecap');
}
